module.exports = __webpack_public_path__ + "static/cross-device-733a28b4555d9d20682c52469b5bdcff.png";